import type { AxiosRequestConfig } from "axios";
import { getCsrfToken } from "@/lib/auth/cookies";

export function csrfHeaders(): Record<string, string> {
  const token = getCsrfToken();
  return token ? { "X-CSRF-Token": token } : {};
}

export function idempotencyHeaders(key?: string): Record<string, string> {
  return key ? { "X-Idempotency-Key": key } : {};
}

export const handledErrorConfig: AxiosRequestConfig = { skipErrorToast: true };
